import { useState } from "react";

interface ManagerAvatarProps {
  name: string;
  logoUrl: string | null;
}

/**
 * A manager's team logo in a circle. Falls back to their initial when Yahoo
 * never gave a logo or the image no longer loads (old seasons' logos can go
 * stale), so the slot is always filled and cards line up.
 */
export function ManagerAvatar({ name, logoUrl }: ManagerAvatarProps) {
  // The address that failed, not a flag: the same avatar is reused for the next manager's profile, whose logo should be tried.
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  if (logoUrl && logoUrl !== failedUrl) {
    return <img className="manager-avatar" src={logoUrl} alt="" loading="lazy" onError={() => setFailedUrl(logoUrl)} />;
  }
  return (
    <span className="manager-avatar manager-avatar--initial" aria-hidden="true">
      {Array.from(name.trim())[0] ?? "?"}
    </span>
  );
}
